module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/GI-001f296baf472b993e5671cf73bc5473.png";